module.exports = __webpack_public_path__ + "img/start-zone-blue.a07fcde3.svg";